import { gql, useQuery } from "@apollo/client";

export type ChartsCountResponse = {
  chartsCount: {
      chartsCount: number;
  };
};

const ChartsCountQuery = gql`
  query charts {
    chartsCount {
      chartsCount
    }
  }
`;

export const useChartsCountQuery = (options: {
  skip?: boolean;
}) =>
  useQuery<ChartsCountResponse>(ChartsCountQuery, {
    fetchPolicy: "no-cache",
    nextFetchPolicy: "cache-first",
    ...options,
  });
